import React from 'react';

/**
 * EstimatActionSection - "Redo att ta nästa steg?"
 * Visar godkänn/neka-knappar för kund eller byggkonsult
 */
const EstimatActionSection = ({
  isApproved,
  isDeclined,
  hasMeetingBooked,
  isCustomerView,
  submitting,
  onApprove,
  onDecline,
}) => {
  // Visa bara om estimatet inte redan beslutats OCH en genomgång har BOKATS
  if (isApproved || isDeclined || !hasMeetingBooked) {
    return null;
  }
  
  return (
    <div className="mt-8 mb-8">
      <div className="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm">
        <div className="p-5 sm:p-8">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
              <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <h3 className="text-base sm:text-lg font-semibold text-gray-900">Redo att ta nästa steg?</h3>
              <p className="text-sm text-gray-500 mt-0.5">Godkänn estimatet för att gå vidare till hembesök</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 mb-6">
            <button
              onClick={onApprove}
              disabled={submitting}
              className="px-6 py-3 bg-green-600 hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white text-sm font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
            >
              {submitting ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Skickar...
                </>
              ) : (
                isCustomerView ? 'Godkänn estimat' : 'Godkänn åt kund'
              )}
            </button>
            <button
              onClick={onDecline}
              disabled={submitting}
              className="px-6 py-3 bg-red-50 border border-red-200 text-red-600 hover:bg-red-100 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed text-sm font-medium rounded-lg transition-colors"
            >
              Tacka nej
            </button>
          </div>

          <div className="border-t border-gray-200 pt-5">
            <p className="text-xs font-medium text-gray-500 mb-3">Vad händer efter godkännande?</p>
            <div className="text-sm text-gray-600 space-y-2">
              <p><span className="font-medium text-gray-700">Hembesök bokas</span> — Vi kontaktar er för att boka ett hembesök</p>
              <p><span className="font-medium text-gray-700">Okulär bedömning</span> — Verifiering av förutsättningar och detaljer på plats</p>
              <p><span className="font-medium text-gray-700">Fastställd offert</span> — Baserat på hembesöket tar vi fram offert</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EstimatActionSection;

